//Speichert und lädt die Daten, mit denen der DeliveryTimeCalculator arbeitet
var variables = {};
var observables = {};
export class Store{
	get(name, throwIfNameNotExists) {
		if (variables[name.toLowerCase()] == null && throwIfNameNotExists === true )
			throw new Error('Variable ' + name + ' doesn\'t exist');
		return variables[name.toLowerCase()];
	}

	set(name, value) {
		if (name == null || value == null)
			throw new Error('name or value not defined');

		var newValue = typeof value == 'function' ? value() : value;
		variables[name.toLowerCase()] = newValue;

		this.notify(name.toLowerCase(), newValue);
	}

	watch(names, observable) {
		if (names == null || observable == null)
			throw new Error('name or observable not defined');

		var namesArray = Array.isArray(names) ? names : [names];

		namesArray.forEach((name,b,c) => {
			var listeners = observables[name.toLowerCase()] || [];
			listeners.push(observable);
			observables[name.toLowerCase()] = listeners;
		});
	}

	notify(name, value) {
		var listeners = observables[name];

		if (!listeners)
			return;

		var oldValue = variables[name.toLowerCase()];


		listeners.forEach(observable => {
			observable(value, oldValue, variables);
		});
	}

	allVariables() {
		return variables;
	}
}

export default Store;


// WEBPACK FOOTER //
// ./src/scripts/op/productionTimeCalculation/Store.es6.js